// platform.ts — PSTUDIO-3623. Pure OS sniff for the shortcuts panel's default
// tab. Mirrors the inline check in controls-bar.tsx; extracted so it is unit-
// testable (node env) and reused by the panel + the ⌘/ predicate's callers.
export type Platform = 'mac' | 'windows';

export function detectPlatform(
  nav: Pick<Navigator, 'platform' | 'userAgent'> = navigator
): Platform {
  const probe = nav.platform || nav.userAgent || '';
  return /Mac|iPhone|iPad|iPod/.test(probe) ? 'mac' : 'windows';
}
